import { User } from "types/user";
import client from "./client";

export const fetchMe = async (): Promise<User> => {
  return await client
    .get("/profiles/me")
    .then(response => response.data.response);
};

export const fetchUsers = async (): Promise<User[]> => {
  const params = {
    order: ["first_name", "ASC"]
  };
  return await client
    .get("/profiles", { params })
    .then(response => response.data.response);
};

export const fetchClientUsers = async (): Promise<User[]> => {
  const params = {
    order: ["first_name", "ASC"]
  };
  return await client
    .get("profiles/list-clients", { params} )
    .then(response => response.data.response);
};

export const fetchAdminUsers = async (): Promise<User[]> => {
  const params = {
    order: ["first_name", "ASC"]
  };
  return await client
    .get("/profiles/list-admins", { params })
    .then(response => response.data.response);
};

export const createUser = async ({
  privs = 0,
  copy_id,
  ...rest
}: User & { copy_id?: string }): Promise<User | null> => {
  return await client
    .post("/profiles/", {
      attributes: {
        ...rest,
        privs
      },
      copyFrom: copy_id
    })
    .then(response => response.data.response);
};

export const updateUser = async ({ id, ...rest }: User): Promise<User> => {
  return await client
    .put(`/profiles/${id}`, {
      attributes: {
        ...rest
      }
    })
    .then(response => response.data.response);
};

export const deleteUser = async ({ id }: User): Promise<User> => {
  return await client
    .delete(`/profiles/${id}`)
    .then(response => response.data.response);
};

export const fetchLoginLink = async (id: string): Promise<string> => {
  return await client
    .get(`/profiles/get-login-link/${id}`)
    .then(response => response.data.response);
};

export const sendLoginEmail = async (id: string): Promise<any> => {
  return client
    .post(`/profiles/send-login-email/${id}`)
    .then(response => response.data.response);
};
